// // import React from "react";
// // import { FaHeart, FaShoppingCart, FaEye } from "react-icons/fa";
// // import "./FeaturedProducts.css";

// // const ProductCard = ({ product = {}, isActive, onClick }) => {
// //   if (!product.name) return null;

// //   const { image, name, price, rating } = product;

// //   return (
// //     <div
// //       className={`card product-card ${isActive ? "active" : ""}`}
// //       onClick={onClick}
// //     >
// //       <div className="product-img">
// //         {image ? (
// //           <img src={image} alt={name} className="card-img-top" />
// //         ) : (
// //           <p>No Image</p>
// //         )}
// //       </div>

// //       <div className="card-body text-center">
// //         <p className="ff-poppins fw-400 fs-14 card-title featured-prod-name">
// //           {name}
// //         </p>
// //         <p className="ff-poppins fw-500 fs-16 feature-price">
// //           ${price.toFixed(2)}
// //         </p>

// //         <div className="stars">
// //           {Array.from({ length: 5 }, (_, index) =>
// //             index < rating ? (
// //               <span key={index} className="star-filled">
// //                 ★
// //               </span>
// //             ) : (
// //               <span key={index} className="star-empty">
// //                 ☆
// //               </span>
// //             )
// //           )}
// //         </div>
// //       </div>

// //       {/* Icons */}
// //       {/* <div className="card-footer d-flex justify-content-between">
// //         <FaHeart className="icon" />
// //         <FaEye className="icon" />
// //         <FaShoppingCart className="cart-icon" />
// //       </div> */}
// //       <div className="card-footer">
// //         <div className="left-icons">
// //           <FaHeart className="icon" />
// //           <FaEye className="icon" />
// //         </div>
// //         <div className="right-icon">
// //           <FaShoppingCart className="cart-icon" />
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ProductCard;
// import React from "react";
// import { FaHeart, FaShoppingCart, FaEye } from "react-icons/fa";
// import "./FeaturedProducts.css";

// const ProductCard = ({ product = {}, isActive, onClick }) => {
//   if (!product.name) return null;

//   const { image, name, price, rating = 0 } = product; // Default rating to 0

//   return (
//     <div
//       className={`card product-card-fe ${isActive ? "active" : ""}`}
//       onClick={onClick}
//     >
//       <div className="product-img">
//         {image ? (
//           <img src={image} alt={name} className="card-img-top" />
//         ) : (
//           <p>No Image</p>
//         )}
//       </div>

//       <div className="card-body text-center">
//         <p className="ff-poppins fw-400 fs-14 card-title featured-prod-name">
//           {name}
//         </p>
//         <p className="ff-poppins fw-500 fs-16 feature-price">
//           ${price.toFixed(2)}
//         </p>

//         {/* Stars Section */}
//         <div className="stars">
//           {[...Array(5)].map((_, index) => (
//             <span key={index} className={index < rating ? "star-filled" : "star-empty"}>
              
//             </span>
//           ))}
//         </div>
//       </div>

//       {/* Icons */}
//       <div className="card-footer">
//         <div className="left-icons">
//           <FaHeart className="icon" />
//           <FaEye className="icon" />
//         </div>
//         <div className="right-icon">
//           <FaShoppingCart className="cart-icon" />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductCard;


import React, { useEffect, useState } from 'react';
import ProductCard from './ProductCard';
import { getWithoutTokenAPI } from '../../util/Api';

const ProductList = () => {
  const [productList, setProductList] = useState([]);

  // const fetchProducts = async () => {
  //   try {
  //     const response = await getWithoutTokenAPI('/product/find-all');
  //     if (response?.statusCode === 200) {
  //       setProductList(response.data?.Product || []);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching products:", error);
  //   }
  // };
  // useEffect(() => {
    

  //   fetchProducts();
  // }, [productList]);

  return (
    <div className="product-grid">
      {productList.map(product => (
        <ProductCard key={product._id} product={product} />
      ))}
    </div>
  );
};

export default ProductList;

